<div class="text-center recuadro">
    <b class="textResult">{{total | i18nPlural: totalMap[0]}}<br><b class="total" *ngIf="total>0">{{total}} </b>{{total
        | i18nPlural: totalMap[1]}}</b>
</div>